import { z } from 'zod';
import { unidadMaterialEnum, categoriaEnum } from './enums';

export const createMaterialSchema = z.object({
  nombre: z.string().min(1, 'El nombre es requerido').max(300),
  sku: z.string().max(50).optional().nullable(),
  unidad: unidadMaterialEnum,
  precioUnitario: z.number().min(0, 'El precio unitario no puede ser negativo'),
  categoria: categoriaEnum,
  presentacion: z.string().max(200).optional().nullable(),
  rendimiento: z.number().min(0).optional().nullable(),
  rendimientoUnidad: z.string().max(20).optional().nullable(),
});

export type CreateMaterialInput = z.infer<typeof createMaterialSchema>;

export const updateMaterialSchema = createMaterialSchema.partial().extend({
  isActive: z.boolean().optional(),
});
export type UpdateMaterialInput = z.infer<typeof updateMaterialSchema>;

export const listMaterialsSchema = z.object({
  search: z.string().optional(),
  categoria: categoriaEnum.optional(),
  notCategoria: categoriaEnum.optional(),
  isActive: z.preprocess(
    (val) => (val === 'true' ? true : val === 'false' ? false : val),
    z.boolean().optional().default(true),
  ),
  page: z.coerce.number().int().positive().default(1),
  limit: z.coerce.number().int().positive().max(100).default(20),
});
export type ListMaterialsInput = z.infer<typeof listMaterialsSchema>;

export const materialParamsSchema = z.object({
  id: z.string().uuid('ID de material inválido'),
});
export type MaterialParams = z.infer<typeof materialParamsSchema>;
